import React from 'react';

import styles from './bannerStyles';

const Banner = ({ children, error }) => (
  <div className={`${styles.bannerContainer} ${error && styles.error}`}>
    <div className={styles.bannerContent}>{children}</div>
  </div>
);

export default Banner;
